const mapStyles = [
  {
    featureType: 'road.highway',
    stylers: [{ color: '#E7E7E7' }], // pipgrey-light
  },
  {
    featureType: 'road.highway.controlled_access',
    stylers: [{ color: '#E7E7E7' }], // pipgrey-light
  },
  {
    featureType: 'road.arterial',
    stylers: [{ color: '#E7E7E7' }], // pipgrey-light
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'all',
    elementType: 'labels.text',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'road',
    elementType: 'labels.text',
    stylers: [{ visibility: 'on' }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text',
    stylers: [{ visibility: 'on' }],
  },
];
export default mapStyles;
